<template>
    <div>
        <div class="overlay" @click="closeMenu"></div>

        <div class="swipe-modal-container">

            <div class="menu-container"
            @touchstart="onTouchStart"
            @touchmove="onTouchMove"
            @touchend="onTouchEnd"
            :style="{ transform: `translateY(${menuTranslateY}px)` }"
            >
                <div class="stripe"></div>
                <slot></slot>
            </div>

        </div>
    </div>
</template>
<script >

export default {
  name: 'SwipeModalComponent',
  props: ['isOpened', 'blockScroll'],
  emits: ['closeMenu', 'componentEvent'],
  components: {
  },
  data () {
    return {
      touchStartY: 0,
      menuTranslateY: 0
    }
  },
  computed: {
  },
  methods: {
    closeMenu: function () {
      this.$emit('closeMenu')
    },
    onTouchStart (event) {
      this.touchStartY = event.touches[0].clientY
    },
    onTouchMove (event) {
      if (!this.blockScroll) {
        const touchY = event.touches[0].clientY
        const deltaY = touchY - this.touchStartY
        if (deltaY < 0) {
          return
        }

        this.menuTranslateY = deltaY
      }
    },
    onTouchEnd (event) {
      const touchY = event.changedTouches[0].clientY
      const deltaY = touchY - this.touchStartY
      if (deltaY > 100 && !this.blockScroll) {
        this.closeMenu()
      }
      // Reinicie a posição do menu
      this.menuTranslateY = 0
    }
  }
}
</script>

<style lang="less" scoped>
.overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: var(--real-vh);
    top: 50%;
    left: 50%;
    z-index: 11;
    transform: translate(-50%, -50%);
    background: rgba(0, 0, 0, 0.21);
}

.swipe-modal-container {
    position: fixed;
    height: auto;
    width: 100vw;
    max-width: 100%;
    overflow: hidden;
    bottom: 0;
    left: 0;
    display: none;
    transition: all linear .2s;
    z-index: 12;
    transform: translateY(0);
    display: block;

    .menu-container {
        position: relative;
        display: block;
        background: white;
        width: calc(100vw - 30px);
        max-height: calc(var(--real-vh) - 70px);
        padding: 15px 15px 0 15px;
        overflow: hidden;
        overflow-y: auto;
        border-radius: 20px 20px 0 0;

        .stripe {
            position: relative;
            display: block;
            width: 35px;
            height: 4px;
            background: #B4B4B4;
            border-radius: 30px;
            margin: 25px auto 25px auto;
        }
    }
}
</style>
